module.exports = __webpack_public_path__ + "static/resume-689488d56dc3703926510a5bbe274d3c.pdf";